import React, { useEffect } from 'react'
import { Route, Redirect } from 'react-router-dom'
import { isAuth } from 'utils/auth'
import history from 'utils/history'

export const PrivateRoute = ({ component: Component, children, ...rest }) => {
	useEffect(() => {
		window.scrollTo(0, 0)
	}, [history.location.pathname])
	return (
		<Route
			{...rest}
			render={(props) =>
				isAuth() ? (
					children ? (
						children
					) : (
						<div className='overflowed'>
							<Component {...props} />
						</div>
					)
				) : (
					<Redirect
						to={{
							pathname: `/login`,
							state: { from: props.location },
						}}
					/>
				)
			}
		/>
	)
}
